/**
 * Shared trader-emotion palette.
 *
 * Used by the Journal form (chip picker per phase) and the trade-list row
 * (compact emoji badges). Keys are short slugs so they're stable in the
 * database; labels + emojis are the render-time surface.
 *
 * Kept intentionally small — 12 slots covers the full arc of a trade
 * without turning the form into a mood ring. Order is emotional weight
 * (positive → neutral → negative) so the picker reads left-to-right as
 * "how did that phase actually feel."
 */
export const EMOTIONS = [
  { key: "confident",  label: "Confident",  emoji: "💪" },
  { key: "calm",       label: "Calm",       emoji: "😌" },
  { key: "focused",    label: "Focused",    emoji: "🧠" },
  { key: "cool",       label: "Cool",       emoji: "😎" },
  { key: "excited",    label: "Excited",    emoji: "🤩" },
  { key: "satisfied",  label: "Satisfied",  emoji: "🙂\u200d↕\ufe0f" },
  { key: "doubtful",   label: "Doubtful",   emoji: "🤔" },
  { key: "anxious",    label: "Anxious",    emoji: "😬" },
  { key: "fomo",       label: "FOMO",       emoji: "🥵" },
  { key: "fearful",    label: "Fearful",    emoji: "😨" },
  { key: "frustrated", label: "Frustrated", emoji: "😤" },
  { key: "regretful",  label: "Regretful",  emoji: "😔" },
];

export const EMOTION_KEYS = EMOTIONS.map((e) => e.key);

const EMOTION_LOOKUP = Object.fromEntries(EMOTIONS.map((e) => [e.key, e]));

export function getEmotion(key) {
  return key ? EMOTION_LOOKUP[key] || null : null;
}

/**
 * The three trade phases the journal captures a feeling for.
 * `field` matches the backend column so callers can read/write cleanly.
 */
export const EMOTION_PHASES = [
  { field: "emotion_entry",      label: "Entry",      hint: "How you felt clicking buy/sell" },
  { field: "emotion_management", label: "Management", hint: "How the trade felt while it ran" },
  { field: "emotion_exit",       label: "Exit",       hint: "How you felt closing (or getting stopped)" },
];
